import { Inject } from '@odinjs/odin';

import { Endpoint, Return, ReturnStatus, SSOService } from '@philips-emr/hpms-provider-commons';
import { ButtonAPI, FieldAPI, FormAPI, PanelAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnChange, OnClick, OnClose, OnMount, OnValidate } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, ValidateEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';
import { applicationContext } from '@philips-emr/tws-foundation';

import './reset-pw-controller.scss';
import { ResetPwAliases as Aliases, FragmentNames } from '../../codegen';
import { FOUNDATION_ROUTES } from '../../route';

@Controller({ fragment: FragmentNames.RESET_PW })
class ResetPwController {

  @Inject(Aliases.FORM_RESET_PW)
  private formResetPassword: FormAPI;

  @Inject(Aliases.PANEL_LOADER)
  private panelLoader: PanelAPI;

  @Inject(Aliases.PANEL_ACTIONS)
  private panelActions: PanelAPI;

  @Inject(Aliases.PANEL_SUCCESS)
  private panelSuccess: PanelAPI;

  @Inject(Aliases.PANEL_SCREEN)
  private panelScreen: PanelAPI;

  @Inject(Aliases.FIELD_RECAPTCHA)
  private fieldRecaptcha: FieldAPI;

  @Inject(Aliases.BUTTON_CONFIRM)
  private buttonConfirm: ButtonAPI;

  @Inject(Aliases.TOAST_NOTIFICATION)
  private toastNotificationApi: ToastNotificationAPI;

  @OnMount(Aliases.PANEL_SCREEN)
  onMountPanel(): void {
    SSOService.ssoEnabled();
  }

  @OnClose(Aliases.MODAL_RESET_PW)
  onClose(): void {
    applicationContext.redirect(FOUNDATION_ROUTES.LOGIN);
  }

  @OnClose(Aliases.TOAST_NOTIFICATION)
  onCloseToast(): void {
    this.toastNotificationApi.setVisible(false);
  }

  @OnValidate(Aliases.FORM_RESET_PW)
  onValidateForm(event: ValidateEvent): void {
    const { valid } = event;

    this.buttonConfirm.setEnabled(valid);
  }

  @OnChange(Aliases.FORM_RESET_PW)
  onChangeForm(): void {
    if (this.toastNotificationApi.isVisible()) {
      this.toastNotificationApi.setVisible(false);
    }
  }

  @OnClick(Aliases.BUTTON_CONFIRM)
  onClick(): void {
    if (this.formResetPassword.validate()) {
      this.panelLoader.setVisible(true);
      this.panelActions.setVisible(false);

      const { username } = this.formResetPassword.getRecord();
      const body = { nameWebUser: username };

      HttpService.post<Return<string>>(Endpoint.POST.RESET_PW, {}, { body })
        .then(() => {
          this.panelScreen.setVisible(false);
          this.panelSuccess.setVisible(true);
        }).catch(resp => {
          const { body: respBody } = resp;

          this.panelLoader.setVisible(false);
          this.panelActions.setVisible(true);

          const w = window as unknown as { grecaptcha: { reset: Function } };
          this.fieldRecaptcha.setValue('');
          w.grecaptcha.reset();

          this.resetValidations();

          const { response, status } = respBody;

          if (status === ReturnStatus.WARNING) {
            this.showToastForm(ToastLevel.WARNING, response);
            return;
          }

          this.showToastForm(ToastLevel.ERROR, resp.body);
        });
    }
  }

  private showToastForm(level: ToastLevel, msg: string): void {
    this.toastNotificationApi.setMessage(msg);
    this.toastNotificationApi.setVisible(true);
    this.toastNotificationApi.setLevel(level);
  }

  private resetValidations(): void {
    this.formResetPassword.setEditing(false);
    this.formResetPassword.setEditing(true);
  }

  @OnClick(Aliases.BUTTON_OK)
  onClickOk(): void {
    applicationContext.redirect(FOUNDATION_ROUTES.LOGIN);
  }

  @OnAfterFetch(Aliases.FETCH_RECAPTCHA)
  onAfterFetch(event: FetchEvent): void {
    if (!event.data) {
      return;
    }
    this.formResetPassword.setLoading(false);
  }

}

export default ResetPwController;
